'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Llocales_cldr_CurrencyData(currencyTypes, fractions, regions, numericCodes) {
  this.vP = null;
  this.vQ = null;
  this.vS = null;
  this.vR = null;
  this.vP = currencyTypes;
  this.vQ = fractions;
  this.vS = regions;
  this.vR = numericCodes;
}
export { $c_Llocales_cldr_CurrencyData as $c_Llocales_cldr_CurrencyData };
$p = $c_Llocales_cldr_CurrencyData.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_cldr_CurrencyData;
/** @constructor */
function $h_Llocales_cldr_CurrencyData() {
}
export { $h_Llocales_cldr_CurrencyData as $h_Llocales_cldr_CurrencyData };
$h_Llocales_cldr_CurrencyData.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_CurrencyData)) {
    var x = this.vP;
    var x$2 = x$0.vP;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.vQ;
      var x$4 = x$0.vQ;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.vS;
      var x$6 = x$0.vS;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.vR;
      var x$8 = x$0.vR;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 4;
});
$p.o = (function() {
  return "CurrencyData";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.vP;
      break;
    }
    case 1: {
      return this.vQ;
      break;
    }
    case 2: {
      return this.vS;
      break;
    }
    case 3: {
      return this.vR;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Llocales_cldr_CurrencyData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dZ)));
}
export { $isArrayOf_Llocales_cldr_CurrencyData as $isArrayOf_Llocales_cldr_CurrencyData };
var $d_Llocales_cldr_CurrencyData = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_cldr_CurrencyData, "locales.cldr.CurrencyData", ({
  dZ: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Llocales_cldr_CurrencyData as $d_Llocales_cldr_CurrencyData };
